export default __webpack_public_path__ + "media/images/icons/group-d0b22f0d348e377bd65b5082a7780a02.svg";